import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { SubmissionSearchProvider } from './context/submission-search-context';
import { SubmissionSearchComponent } from './submission-search-component';

export function SubmissionSearchFactory() {
    return (
        <BaseLayoutFactory>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <SubmissionSearchProvider>
                    <SubmissionSearchComponent />
                </SubmissionSearchProvider>
            </LocalizationProvider>
        </BaseLayoutFactory>
    );
}
